<template>
  <div>
    <div class="font-bold p-2">Table</div>

    <div v-if="!hasBookedSeatsInSelection" class="flex gap-2 px-2 text-gray-300">
      <SMButton v-tippy="'Duplicate'" icon="copy" :on-click="duplicate" />
      <SMButton v-tippy="'Delete'" icon="delete" :on-click="remove" />
    </div>

    <ul class="space-y-2 p-2">
      <li class="flex">
        <SMNumberInput
          v-model="chairsCount"
          v-tippy="'Chairs count'"
          :min="chairsMin"
          :max="20"
          icon="seat"
          :interval="1"
          class="w-full"
          @update:modelValue="onChairsCountValueChange"
        />
      </li>
      <li class="flex">
        <SMNumberInput
          v-model="openSpacesCount"
          v-tippy="'Open spaces'"
          :min="0"
          :max="20"
          icon="gap"
          :interval="1"
          class="w-full"
          @update:modelValue="onOpenSpacesValueChange"
        />
      </li>
      <li class="flex">
        <SMNumberInput
          v-model="radiusValue"
          v-tippy="'Table size'"
          icon="enlarge"
          :min="TABLE.ROUNDED.RADIUS / 2"
          :max="80"
          :interval="2"
          class="w-full"
          @update:modelValue="onRadiusValueChange"
        />
      </li>
    </ul>

    <ul v-if="!hasBookedSeatsInSelection && (draftEvent || pauseEvent)" class="space-y-2 px-2 py-1">
      <li>
        <SMInput v-model="meta1" v-tippy="'Meta 1'" icon="1" placeholder="Meta 1" @change="onChangeMeta1" />
      </li>

      <li>
        <SMInput v-model="meta2" v-tippy="'Meta 2'" icon="2" placeholder="Meta 2" @change="onChangeMeta2" />
      </li>
    </ul>
  </div>
</template>
<script lang="ts">
/* eslint-disable */
import SMButton from '@/components/ui/SMButton.vue';
import SMIcon from '@/components/ui/SMIcon.vue';
import SMInput from '@/components/ui/SMInput.vue';
import SMNumberInput from '@/components/ui/SMNumberInput.vue';
import SMSlider from '@/components/ui/SMSlider.vue';
import { EVENTSTATUS, SEATSTATUS, TABLE, TYPE } from '@/constants';
import filter from 'lodash/filter';
import uniq from 'lodash/uniq';
import eventbus from 'tiny-emitter/instance';

export default {
  props: ['unit'],
  components: {
    SMInput,
    SMIcon,
    SMSlider,
    SMButton,
    SMNumberInput
},
  data() {
    return {
      isGrouped: false,
      dragStarted: false,
      chairsCount: TABLE.ROUNDED.SEATSCOUNT,
      openSpacesCount: 0,
      radiusValue: TABLE.ROUNDED.RADIUS,
      TABLE,
      chairsMin: 0
    };
  },
  created() {
    this.chairsCount = this.unit.seats.length;
    this.radiusValue = this.unit.radius;
    this.openSpacesCount = this.unit.openSpaces;
    this.isGrouped = this.unit.attributes.isGrouped;
    if (this.unit) {
      // check if the unit has blocked or cart seats
      this.blockedSeatsCount = filter(this.unit.seats, (s) => s.locked).length;
      this.occupiedSeatsCount = filter(
        this.unit.seats,
        (s) => s.attributes.status === SEATSTATUS.OCCUPIED || s.attributes.status === SEATSTATUS.RESERVED
      ).length;
      this.cartSeatsCount = filter(this.unit.seats, (s) => s.attributes.status === SEATSTATUS.CART).length;
      this.chairsMin = this.blockedSeatsCount + this.cartSeatsCount + this.occupiedSeatsCount;
    }
  },
  computed: {
    draftEvent() {
      return this.$app.props.status === EVENTSTATUS.DRAFT;
    },
    pauseEvent() {
      return this.$app.props.status === EVENTSTATUS.PAUSED;
    },
    meta1() {
      return this.unit.attributes.meta1;
    },
    meta2() {
      return this.unit.attributes.meta2;
    },
    checkIfMultipleCategory() {
      let assignedCats = [];
      this.unit.seats.forEach((s) => {
        if (s.attributes.categoryId) {
          const categoryId = s.attributes.categoryId.toString().trim();
          assignedCats.push(categoryId);
        }
      });
      assignedCats = uniq(assignedCats);
      return assignedCats.length > 1;
    },
    hasBookedSeatsInSelection() {
      let bookedUnits = 0;
      if (this.unit.seats.length > 0) {
        this.unit.seats.forEach((u) => {
          if (u.type === TYPE.TABLESEAT) {
            bookedUnits +=
              u.attributes.status === SEATSTATUS.OCCUPIED ||
              u.attributes.status === SEATSTATUS.RESERVED ||
              u.attributes.status === SEATSTATUS.CART
                ? 1
                : 0;
          } else if (u.type === TYPE.TABLE) {
            const bookedTableSeats = u.seats.filter(
              (s) =>
                s.attributes.status === SEATSTATUS.OCCUPIED ||
                s.attributes.status === SEATSTATUS.RESERVED ||
                s.attributes.status === SEATSTATUS.CART
            );
            bookedUnits += bookedTableSeats.length > 0 ? 1 : 0;
          }
        });
      }
      return !!bookedUnits;
    },
  },
  watch: {
    chairsCount(newVal, oldVal) {
      this.unit.seats.forEach((s) => {
        // redraw lockshape for locked seats
        if (s.locked) {
          s.removeLockClass();
          s.removeLockShape();
          s.addLockClass();
          s.initLockShape();
          s.initReservedShape();
          s.initCartShape();
        }
      });
    },
  },
  methods: {
    onChangeMeta1(value) {
      this.$app.seatmap.triggerUnsavedChanges(true);
      this.unit.changeMeta1(value.trim());
    },
    onChangeMeta2(value) {
      this.$app.seatmap.triggerUnsavedChanges(true);
      this.unit.changeMeta2(value.trim());
    },

    onDragStart() {
      this.unit.seats.forEach((s) => {
        if (s.locked) {
          s.removeLockClass();
          s.removeLockShape();
        }
        if (s.disabled) {
          s.removeDisabledClass();
          s.removeDisabledShape();
        }
      });
      this.dragStarted = true;
    },
    onDragEnd() {
      this.unit.seats.forEach((s) => {
        if (s.locked) {
          s.addLockClass();
          s.initLockShape();
        }
        if (s.disabled) {
          s.addDisabledClass();
          s.initDisabledShape();
        }
      });
      this.dragStarted = false;
    },
    resetGroupSeating() {
      this.unit.seats.forEach((item) => {
        item.enable();
        item.removeFromPreviousGroup();
      });
    },
    onChairsCountValueChange(value) {
      this.resetGroupSeating();
      this.unit.changeSeatsCount(value);

      eventbus.emit('selection:delayedHistory', 'Round table chair count change');
      eventbus.emit('seatmap:updated', this.$app.seatmap.seats, this.$app.seatmap.units, this.$app.seatmap.sections);
      eventbus.emit('selection:updated', this.$app.seatmap.selection);
    },
    onOpenSpacesValueChange(value) {
      this.unit.openSpaces = value;

      eventbus.emit('selection:delayedHistory', 'Round table open space change');
    },
    onRadiusValueChange(value) {
      this.unit.changeRadiusManually(value);

      eventbus.emit('selection:delayedHistory', 'Round table radius change');
    },
    onInputClick() {
      // intentionally left blank
    },
    duplicate() {
      eventbus.emit('selection:clone');
    },
    remove() {
      eventbus.emit('selection:remove');
    },
    onCheckboxToggle(val) {
      this.$app.seatmap.triggerUnsavedChanges(true);
      this.unit.attributes.isGrouped = val;
      this.resetGroupSeating();
    },
  },
};
</script>
<style lang="scss"></style>
